  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import SettingsChangeMobileStyle                             from "./SettingsChangeMobileStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "SettingsChangeMobile ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var SettingsChangeMobile_continue_locked = true;

  //[flagsimages]
  var images = null;

class SettingsChangeMobile extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,
      dialog_goBack_msg                                    : "",
      dialog_goBack_isOpen                                 : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      phonePrefix_old_id                                   : "",               //DropDown
      phonePrefix_old_text                                 : "",
      phonePrefix_old_hasError                             : false,
      phonePrefix_old_AUTOCOMPLETE_MODE                    : "object", //"text","object";
      phonePrefix_old_AUTOCOMPLETE_FILTER_OPTIONS          : "any",    //"start","any"
      phoneNumber_old                                      : "",               //TextField
      phoneNumber_old_hasError                             : false,

      phonePrefix_new_id                                   : "",               //DropDown
      phonePrefix_new_text                                 : "",
      phonePrefix_new_hasError                             : false,
      phonePrefix_new_AUTOCOMPLETE_MODE                    : "object", //"text","object";
      phonePrefix_new_AUTOCOMPLETE_FILTER_OPTIONS          : "any",    //"start","any"
      phoneNumber_new                                      : "",               //TextField
      phoneNumber_new_hasError                             : false,

      textField1                                           : "",
      textField1_hasError                                  : false,
      last_updateMobileTriggerOTP_timestamp                : null,

      btn_next_state                                       : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.dialog_goBack_handleClose                                   = this.dialog_goBack_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.resendCodeButton_btnClick                                   = this.resendCodeButton_btnClick.bind(this);
    this.resendCodeButton_btnClick_isDisabled                        = this.resendCodeButton_btnClick_isDisabled.bind(this);

    this.handleCustomDropDownClick_phonePrefix_old                   = this.handleCustomDropDownClick_phonePrefix_old.bind(this);
    this.handleCustomDropDownClick_phonePrefix_new                   = this.handleCustomDropDownClick_phonePrefix_new.bind(this);

    this.btn_save_act                                                = this.btn_save_act.bind(this);
    this.btn_save_act_isDisabled                                     = this.btn_save_act_isDisabled.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //[Lockers]
    this.stopLockers();

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++++++
      //Login Screen
      //++++++++++++
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
      return;
    }

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    this.setState({
      "btn_next_state" : this.NSInforString("ChangeMobile_btn_verify")
    });

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsChangeMobile"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    var res_obj = wu_StaticDataService.wu_getPhonePrefixes({});
    var parserObject_getPhonePrefixes4Picker = [];
    for(var i=0; i<res_obj.phone_prefixes.length; ++i){ parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]); }
    this.setState({
      "parserObject_getPhonePrefixes"        : res_obj.phone_prefixes,
      "parserObject_getPhonePrefixes4Picker" : parserObject_getPhonePrefixes4Picker
    });
    //-------------------
    //wu_validatecustomer
    //-------------------
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="SettingsChangeMobile"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let ws_phone            = "";
      let ws_isMobile         = 0;
      try {ws_phone            = res.customer["phone"];            }catch(err){;} if(ws_phone            === null || (typeof ws_phone            ==="undefined")){ws_phone            = "";}
      try {ws_isMobile         = res.customer["isMobile"];         }catch(err){;} if(ws_isMobile         === null || (typeof ws_isMobile         ==="undefined")){ws_isMobile         = 0; }

      let phonePrefix = "";
      let phoneNumber = "";
      try {phonePrefix = ws_phone.split("-")[0]; }catch(err){;} if(phonePrefix === null || (typeof phonePrefix ==="undefined")){phonePrefix = "";}
      try {phoneNumber = ws_phone.split("-")[1]; }catch(err){;} if(phoneNumber === null || (typeof phoneNumber ==="undefined")){phoneNumber = "";}

      this.setState({
        phonePrefix_old_id                                   : phonePrefix,
        phonePrefix_old_text                                 : this.state.phonePrefix_old_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findPhonePrefixNameFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")) : wu_Utilities.findPhonePrefixObjFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")),
        phonePrefix_old_hasError                             : false,
        phoneNumber_old                                      : phoneNumber,
        isMobile_old                                         : (ws_isMobile===1 || ws_isMobile==="1") ? true : false,

        phonePrefix_new_id                                   : phonePrefix,
        phonePrefix_new_text                                 : this.state.phonePrefix_new_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findPhonePrefixNameFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")) : wu_Utilities.findPhonePrefixObjFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")),
        phonePrefix_new_hasError                             : false,
        phoneNumber_new                                      : "",
        isMobile_new                                         : true,
      });
    })
    .catch(err => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //-----------
    //PhonePrefix---old
    //-----------
    let defaultPropsPhonePrefix_old   = {};
    let filterOptionsPhonePrefix_old  = {};
    if(this.state.phonePrefix_old_AUTOCOMPLETE_MODE === "text"){
      defaultPropsPhonePrefix_old   = { options:this.state.parserObject_getPhonePrefixes4Picker, getOptionLabel:option => option, };
      filterOptionsPhonePrefix_old  = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsPhonePrefix_old = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      else                                   { defaultPropsPhonePrefix_old = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      filterOptionsPhonePrefix_old = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr + option.keywords,});
    }
    //-----------
    //PhonePrefix---new
    //-----------
    let defaultPropsPhonePrefix_new   = {};
    let filterOptionsPhonePrefix_new  = {};
    if(this.state.phonePrefix_new_AUTOCOMPLETE_MODE === "text"){
      defaultPropsPhonePrefix_new   = { options:this.state.parserObject_getPhonePrefixes4Picker, getOptionLabel:option => option, };
      filterOptionsPhonePrefix_new  = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsPhonePrefix_new = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      else                                   { defaultPropsPhonePrefix_new = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      filterOptionsPhonePrefix_new = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr + option.keywords,});
    }

    // const defaultPropsPhonePrefix_old = {
    //   options        : this.state.parserObject_getPhonePrefixes4Picker,
    //   getOptionLabel : option => option,
    // };
    // const defaultPropsPhonePrefix_new = {
    //   options        : this.state.parserObject_getPhonePrefixes4Picker,
    //   getOptionLabel : option => option,
    // };

    let btn_next_state_TMP = (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify") ? this.NSInforString("ChangeMobile_btn_verify") : this.NSInforString("ChangeMobile_btn_save");

    let ChangeMobile_plh02_TMP = (this.state.phonePrefix_old_id === "30" && this.verifyGenericItem("phone_landline",this.state.phoneNumber_old)) ? this.NSInforString("ChangeMobile_plh02_phone") : this.NSInforString("ChangeMobile_plh02");

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ChangeMobile_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ChangeMobile_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              {this.state.phonePrefix_old_AUTOCOMPLETE_MODE === "text" ? (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix_old}>
                  <Autocomplete
                    disabled
                    {...defaultPropsPhonePrefix_old}
                    id="phonePrefix_old"
                    value={this.state.phonePrefix_old_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix_old(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_old_hasError} label={this.NSInforString("ChangeMobile_plh01")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                  />
                </FormControl>
              </GridItem>
              ) : (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix_old}>
                  <Autocomplete
                    filterOptions={filterOptionsPhonePrefix_old}
                    disabled
                    {...defaultPropsPhonePrefix_old}
                    id="phonePrefix_old"
                    value={this.state.phonePrefix_old_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix_old(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option.descr)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_old_hasError} label={this.NSInforString("ChangeMobile_plh01")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                  />
                </FormControl>
              </GridItem>
              ) }
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  disabled
                  fullWidth
                  error={this.state.phoneNumber_old_hasError}
                  className={classes.phoneNumber_old}
                  id="phoneNumber_old"
                  label={ChangeMobile_plh02_TMP}
                  value={this.state.phoneNumber_old}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "phoneNumber_old"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center" style={{marginTop:20}}>
              {this.state.phonePrefix_new_AUTOCOMPLETE_MODE === "text" ? (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix_new}>
                  <Autocomplete
                    {...defaultPropsPhonePrefix_new}
                    id="phonePrefix_new"
                    value={this.state.phonePrefix_new_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix_new(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_new_hasError} label={this.NSInforString("ChangeMobile_plh03")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                  />
                </FormControl>
              </GridItem>
              ) : (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix_new}>
                  <Autocomplete
                    filterOptions={filterOptionsPhonePrefix_new}
                    {...defaultPropsPhonePrefix_new}
                    id="phonePrefix_new"
                    value={this.state.phonePrefix_new_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix_new(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option.descr)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_new_hasError} label={this.NSInforString("ChangeMobile_plh03")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                  />
                </FormControl>
              </GridItem>
              ) }
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.phoneNumber_new_hasError}
                  className={classes.phoneNumber_new}
                  id="phoneNumber_new"
                  label={this.NSInforString("ChangeMobile_plh04")}
                  value={this.state.phoneNumber_new}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "phoneNumber_new"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.ChangeMobile_lbl_info1}>{this.NSInforString("ChangeMobile_lbl_info1")}</div>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField1_hasError}
                    className={classes.textField1}
                    id="textField1"
                    value={this.state.textField1}
                    label={this.NSInforString("ChangeMobile_plh05")}
                    defaultValue=""
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: "text"  }}
                  />
                </GridItem>
              </GridContainer>
            ) : ( "" )}

            { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.ChangeMobile_info2}>{this.NSInforString("ChangeMobile_info2")}</div>
            </GridItem>
            ) : ( "" )}

            { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.textCenter}>
                <Button
                  disabled={this.resendCodeButton_btnClick_isDisabled()}
                  className={classes.resendCodeButton}
                  color="default"
                  onClick={this.resendCodeButton_btnClick}
                  type="submit">
                  {this.NSInforString("ChangeMobile_btn_resend")}
                </Button>
              </div>
            </GridItem>
            ) : ( "" )}
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_save_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_save_act}
                    type="submit">
                    {btn_next_state_TMP}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("ChangeMobile_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_goBack_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_goBack_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_goBack_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_goBack_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //https://material-ui.com/components/lists/
  // function generate(element) {
  //   return [0, 1, 2].map(value =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_phonePrefix_old(event,value) {
    let methName = filename+"handleCustomDropDownClick_phonePrefix_old ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.phonePrefix_old_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "phonePrefix_old_text"     : eventTMP1,
      "phonePrefix_old_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getPhonePrefixes4Picker.length; ++i){
      if(this.state.parserObject_getPhonePrefixes4Picker[i]===eventTMP2){
        this.setState({ "phonePrefix_old_id":this.state.parserObject_getPhonePrefixes[i].c2c_wu_id });
        //console.log('this.state.parserObject_getPhonePrefixes[i].c2c_wu_id='+this.state.parserObject_getPhonePrefixes[i].c2c_wu_id);
        if(this.state.parserObject_getPhonePrefixes[i].c2c_wu_id!=="30"){
          this.setState({"phoneNumber_old_hasError" : false });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_phonePrefix_new(event,value) {
    let methName = filename+"handleCustomDropDownClick_phonePrefix_new ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.phonePrefix_new_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "phonePrefix_new_text"     : eventTMP1,
      "phonePrefix_new_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getPhonePrefixes4Picker.length; ++i){
      if(this.state.parserObject_getPhonePrefixes4Picker[i]===eventTMP2){
        this.setState({ "phonePrefix_new_id":this.state.parserObject_getPhonePrefixes[i].c2c_wu_id });
        //console.log('this.state.parserObject_getPhonePrefixes[i].c2c_wu_id='+this.state.parserObject_getPhonePrefixes[i].c2c_wu_id);
        if(this.state.parserObject_getPhonePrefixes[i].c2c_wu_id!=="30"){
          this.setState({"phoneNumber_new_hasError" : false });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  resendCodeButton_btnClick_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  resendCodeButton_btnClick(event) {
    let methName = filename+"resendCodeButton_btnClick ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.phonePrefix_new_text === "")        { this.setState({"phonePrefix_new_hasError"      : true }); emptyFields = true; }//phonePrefix_new_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber_new.trim() === "")      { this.setState({"phoneNumber_new_hasError"      : true }); emptyFields = true; }
      // if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      //   if(this.state.textField1.trim() === "")         { this.setState({"textField1_hasError"           : true }); emptyFields = true; }
      // }
      if(emptyFields===true){this.stopLockers();return;}
    }



    //------------
    //validate OTP
    //------------
    let textField1text   = this.state.textField1.trim();
  //let verificationCode = this.state.textField1.trim();
    if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      if(textField1text === ""){
        this.setState({"textField1_hasError" : true });
      //this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("ChangeMobile_plh05"));
        this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_empty_SMS"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
      }
      if(this.verifyGenericItem("8digitregisterpin",textField1text)===false){
          this.dialog_handleOpen(this.NSInforString("ChangeMobile_8digitpinregister"));
          //if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
          this.stopLockers();return;
      }
    }
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone_old   = this.state.phonePrefix_old_id+"-"+this.state.phoneNumber_old.trim();
    let telephone       = this.state.phonePrefix_new_id+"-"+this.state.phoneNumber_new.trim();
    let textField2text  = this.state.phonePrefix_new_id+"-"+this.state.phoneNumber_new.trim();
    let textField2btext = this.state.phoneNumber_new.trim();
  //let isMobile_new    = "1";
    if(api.print_logs){console.log("this.state.phonePrefix_new_id = "+this.state.phonePrefix_new_id);}
    if(api.print_logs){console.log("this.state.phoneNumber_new    = "+this.state.phoneNumber_new);}
    if(textField2text === ""){
        this.setState({"phonePrefix_new_hasError" : true });
        this.setState({"phoneNumber_new_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("ChangeMobile_plh04")+"\"");
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_new_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_new_id === "30"){
        if(textField2btext.length !== 10){
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
        if(this.verifyGenericItem("phone_mobile",textField2btext)===false){
            console.log('1 this.state.isMobile_new='+this.state.isMobile_new+",textField2btext="+textField2btext);
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    else{
      //if(textField2btext.length < 10 || textField2btext.length>24){
        if(textField2btext.length < 7 || textField2btext.length>24){
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }

    if(telephone_old===telephone){
      this.setState({"phoneNumber_new_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_changeNumber"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }

    event.preventDefault();
    if(this.shouldAllow_updateMobileTriggerOTP(this.state.last_updateMobileTriggerOTP_timestamp)===false){
      this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_wait_for_retry"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-------------------------
      //wu_updateMobileTriggerOTP---resend
      //-------------------------
      wu_ProfileService
      .wu_updateMobileTriggerOTP({mobile:telephone})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsChangeMobile"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();
        this.setState({ "btn_next_state":this.NSInforString("ChangeMobile_btn_save") });
        this.setState({ "last_updateMobileTriggerOTP_timestamp":new Date() });
        this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_info_SMS").replace("[phone number]", telephone));
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  btn_save_act_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_save_act(event) {
    let methName = filename+"btn_save_act ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.phonePrefix_new_text === "")        { this.setState({"phonePrefix_new_hasError"      : true }); emptyFields = true; }//phonePrefix_new_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber_new.trim() === "")      { this.setState({"phoneNumber_new_hasError"      : true }); emptyFields = true; }
      // if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      //   if(this.state.textField1.trim() === "")         { this.setState({"textField1_hasError"           : true }); emptyFields = true; }
      // }
      if(emptyFields===true){this.stopLockers();return;}
    }



    //------------
    //validate OTP
    //------------
    let textField1text   = this.state.textField1.trim();
    let verificationCode = this.state.textField1.trim();
    if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      if(textField1text === ""){
        this.setState({"textField1_hasError" : true });
      //this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("ChangeMobile_plh05"));
        this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_empty_SMS"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
      }
      if(this.verifyGenericItem("8digitregisterpin",textField1text)===false){
          this.dialog_handleOpen(this.NSInforString("ChangeMobile_8digitpinregister"));
          //if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
          this.stopLockers();return;
      }
    }
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone_old   = this.state.phonePrefix_old_id+"-"+this.state.phoneNumber_old.trim();
    let telephone       = this.state.phonePrefix_new_id+"-"+this.state.phoneNumber_new.trim();
    let textField2text  = this.state.phonePrefix_new_id+"-"+this.state.phoneNumber_new.trim();
    let textField2btext = this.state.phoneNumber_new.trim();
  //let isMobile_new    = "1";
    if(api.print_logs){console.log("this.state.phonePrefix_new_id = "+this.state.phonePrefix_new_id);}
    if(api.print_logs){console.log("this.state.phoneNumber_new    = "+this.state.phoneNumber_new);}
    if(textField2text === ""){
        this.setState({"phonePrefix_new_hasError" : true });
        this.setState({"phoneNumber_new_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("ChangeMobile_plh04")+"\"");
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_new_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_new_id === "30"){
        if(textField2btext.length !== 10){
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
        if(this.verifyGenericItem("phone_mobile",textField2btext)===false){
            console.log('1 this.state.isMobile_new='+this.state.isMobile_new+",textField2btext="+textField2btext);
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    else{
      //if(textField2btext.length < 10 || textField2btext.length>24){
        if(textField2btext.length < 7 || textField2btext.length>24){
            this.setState({"phoneNumber_new_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            //if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }

    if(telephone_old===telephone){
      this.setState({"phoneNumber_new_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_changeNumber"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }

    event.preventDefault();
    if(this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify"){
      if(this.shouldAllow_updateMobileTriggerOTP(this.state.last_updateMobileTriggerOTP_timestamp)===false){
        this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_wait_for_retry"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
      }
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //-------------------------
        //wu_updateMobileTriggerOTP
        //-------------------------
        wu_ProfileService
        .wu_updateMobileTriggerOTP({mobile:telephone})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="SettingsChangeMobile"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopLockers();this.stopSpinners();
          this.setState({ "btn_next_state":this.NSInforString("ChangeMobile_btn_save") });
          this.setState({ "last_updateMobileTriggerOTP_timestamp":new Date() });
          this.dialog_handleOpen(this.NSInforString("ChangeMobile_msg_info_SMS").replace("[phone number]", telephone));
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      }.bind(this), 500);
    }
    else{
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------------
        //wu_updateMobileVerifyOTP
        //------------------------
        wu_ProfileService
        .wu_updateMobileVerifyOTP({verificationCode:verificationCode})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="SettingsChangeMobile"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopLockers();this.stopSpinners();
          this.dialog_goBack_handleOpen(this.NSInforString("ChangeMobile_msg_success"));
          this.setState({ "btn_next_state":this.NSInforString("ChangeMobile_btn_verify") });
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      }.bind(this), 500);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="phoneNumber_new"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "phoneNumber_new"          : eventTMP,
        "phoneNumber_new_hasError" : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"           : this.NSInforString("ChangeMobile_btn_verify"),
      });
    }
    else{
      this.setState({ [stateVar] : eventTMP, });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="phone_landline")                   { return wu_Utilities.offline_validate_phone_landline(val);  }
    if(key==="phone_mobile")                     { return wu_Utilities.offline_validate_phone_mobile(val);  }
    if(key==="8digitregisterpin")                { return wu_Utilities.offline_validate_8digitregisterpin(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  shouldAllow_updateMobileTriggerOTP(aDate){
    let methName = filename+"shouldAllow_updateMobileTriggerOTP ";
    if(api.print_logs){console.log(methName);}

    if(aDate === null || (typeof aDate ==="undefined") || aDate===""){
      console.log(methName+"true1");
      return true;
    }
    try{
      var t2     = aDate.getTime();
      var t1     = (new Date()).getTime();
      let diffMS = Math.abs(parseInt(t2-t1));
      if(diffMS > api.OTPRetryPeriodMS){
        console.log(methName+"true2");
        return true;
      }
    }catch(err){
      console.log('err='+err);
    }

    console.log(methName+"false");
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG2"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialog_goBack_handleOpen(dialog_goBack_msg){
    this.setState({
      "dialog_goBack_isOpen" : true,
      "dialog_goBack_msg"    : dialog_goBack_msg
    });
  }
  dialog_goBack_handleClose(){
    this.setState({ "dialog_goBack_isOpen": false });
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( SettingsChangeMobile_continue_locked===true ){ return true;  }
    else                                             { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    SettingsChangeMobile_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    SettingsChangeMobile_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsChangeMobile.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsChangeMobileStyle)(SettingsChangeMobile)
);
